import { Box, Button, Stack, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import TextInputField from "components/PimDashboard/CommonComponents/InputComponents/TextInputField";
import MultipleSelectInput from "components/PimDashboard/CommonComponents/MultipleSelectInput/MultipleSelectInput";
import {
	attrGrpTableStrColumnsObj,
	attributGrpColObj,
	attrTableStrColumnsObj,
	attrValTableStrColumnsObj,
	constraintsAttrColObj,
	constraintsOptions,
	dependencyAttrColObj,
} from "components/PimDashboard/data";
import { GlobalState } from "context/GlobalContext";
import { PimDashboardState } from "context/PimDashboardContext";
import { arrType, inputTypes, selectOptionsKeyName } from "data/globalData";
import { useState } from "react";
import { studioAttrGrpAttrAssocObj, studioAttrValAssocObj } from "../data";
import axios from "axios";
import { parseErrorMessage } from "utils/ErrorFunctions/parseErrorMessage";
import { StudioDashboardState } from "context/StudioDashboardContext";

const AddAttributeValues = ({ selectedAttribute, setSelectedAttribute, disableAdd = false }) => {
	const { setSnackBar, snackBar, setSnackBarOpen, setLoadingOpen } = GlobalState();
	const { attrGroupsWithAttr, setAttrGroupsWithAttr, allAttributes } = StudioDashboardState();
	let defData = Object.keys(selectedAttribute[dependencyAttrColObj.key])?.reduce(
		(acc, row) => {
			acc[dependencyAttrColObj.key][row] = [];
			return acc;
		},
		{ [dependencyAttrColObj.key]: {} }
	);

	console.log("selectedsdcfnbjdsm", selectedAttribute);
	console.log(defData, "defDataData");

	const [attrValData, setAttrValData] = useState(defData);
	const handleConstraintValAdd = (value, depCol) => {
		setAttrValData({
			...attrValData,
			[dependencyAttrColObj.key]: { ...attrValData[dependencyAttrColObj.key], [depCol]: value },
		});
		console.log(value, "valuesd", attrValData);
	};
	const handleConstraintValDelete = (valToDel, depCol) => {
		let obj = attrValData[dependencyAttrColObj.key];
		setAttrValData({
			...attrValData,
			[dependencyAttrColObj.key]: { ...obj, [depCol]: obj[depCol]?.filter((row) => row !== valToDel) },
		});
	};
	const handleFormSubmit = async (e) => {
		e.preventDefault();
		console.log(attrValData, "attrValData");
		// check empty dependency

		try {
			setLoadingOpen(true);
			let attrArr = attrGroupsWithAttr[selectedAttribute[attributGrpColObj.key]][studioAttrGrpAttrAssocObj];
			const res = await axios.post("/api/studio_attr_master/create_attr_val", {
				...attrValData,
				pim_attribute_id: selectedAttribute.key,
			});
			const selectedAttrObj = {
				...selectedAttribute,
				[studioAttrValAssocObj]: [...selectedAttribute[studioAttrValAssocObj], res.data],
				res,
			};
			setSelectedAttribute({ ...selectedAttrObj });
			// setSelectedAttrGroup({
			// 	...selectedAttrGroup,
			// 	[studioAttrGrpAttrAssocObj]: attrArr?.map((row) => {
			// 		if (row.key === selectedAttribute.key) return selectedAttrObj;
			// 		else return row;
			// 	}),
			// });
			setAttrGroupsWithAttr({
				...attrGroupsWithAttr,
				[selectedAttribute[attributGrpColObj.key]]: {
					...attrGroupsWithAttr[selectedAttribute[attributGrpColObj.key]],
					[studioAttrGrpAttrAssocObj]: attrArr?.map((row) => {
						if (row.key === selectedAttribute.key) return selectedAttrObj;
						else return row;
					}),
				},
			});
			setAttrValData({ ...attrValData, [attrValTableStrColumnsObj.value.key]: "" });
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "Attribute Value Added",
				severity: "success",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);
		} catch (error) {
			console.log(error);
			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, message: parseErrorMessage(error) });
			setLoadingOpen(false);
		}
	};
	return (
		<Stack
			spacing={1}
			width="100%"
			sx={{ background: grey[200], p: 2, borderRadius: 1 }}
			component="form"
			onSubmit={handleFormSubmit}>
			<Typography variant="h6">Add Values</Typography>
			{Object.keys(selectedAttribute[dependencyAttrColObj.key])?.map((depCol) => {
				const attrs = allAttributes?.filter((row) => row[attrTableStrColumnsObj.key.key] === depCol) ?? [];
				const optionsList = attrs?.length
					? attrs[0][studioAttrValAssocObj]?.map((row) => row[attrValTableStrColumnsObj.value.key])
					: [];
				console.log(optionsList, "attrs");

				return (
					<MultipleSelectInput
						key={depCol}
						// disabled={selectedAttribute && modalAction === addOrEditModelAction.UPDATE}
						placeHolder={depCol}
						chips={
							attrValData[dependencyAttrColObj.key][depCol]?.length ? attrValData[dependencyAttrColObj.key][depCol] : []
						}
						options={{
							type: arrType,
							list: optionsList,
							// getOptionLabel: (obj) =>  obj[attrValTableStrColumnsObj.value.key],
						}}
						size="medium"
						handleListAdd={(newValArr) => handleConstraintValAdd(newValArr, depCol)}
						onDelete={(valToDel) => handleConstraintValDelete(valToDel, depCol)}
						labelCol={attrValTableStrColumnsObj.value.key}
					/>
				);
			})}
			<TextInputField
				variant="outlined"
				disableLabel
				data={attrValData}
				disabled={selectedAttribute?.input_type === inputTypes.AUTO_GENERATE.key}
				setData={attrValData}
				onChange={(e) => setAttrValData({ ...attrValData, [attrValTableStrColumnsObj.value.key]: e.target.value })}
				column={attrValTableStrColumnsObj.value}
				width={"100%"}
				required
				type={selectedAttribute[attrTableStrColumnsObj.data_type.key]}
			/>
			<Box width="100%">
				<Button
					type="submit"
					variant="contained"
					fullWidth
					sx={{ mt: 2, textTransform: "capitalize", fontSize: "16px" }}
					disabled={disableAdd}>
					Add
				</Button>
			</Box>
		</Stack>
	);
};

export default AddAttributeValues;
